import type { Toast } from '../hooks/useToasts';

export function Toasts({ toasts, onDismiss }: { toasts: Toast[]; onDismiss: (id: number) => void }) {
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <button className="toast" key={t.id} onClick={() => onDismiss(t.id)} title="Dismiss">
          {t.message}
        </button>
      ))}
    </div>
  );
}
